import React from "react";
import { IoHomeSharp } from "react-icons/io5";
import {
  MdLocalPostOffice,
  MdOutlineMiscellaneousServices as MdServices,
} from "react-icons/md";
import { RiProjectorFill } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

const NavbarMenu = () => {
  const { pathname } = useLocation();

  const menuItems = [
    { path: "/", icon: IoHomeSharp, label: "Home" },
    { path: "/projects", icon: RiProjectorFill, label: "Projects" },
    { path: "/services", icon: MdServices, label: "Services" },
    { path: "/aboutme", icon: FaUser, label: "About Me" },
    // { path: "/blog", icon: MdLocalPostOffice, label: "Blog" },
    { path: "/contact", icon: MdLocalPostOffice, label: "Contact" },
  ];

  const isCurrentPath = (path) => {
    if (path === "/projects" && pathname.startsWith("/projects")) {
      return true;
    }
    return pathname === path;
  };

  return (
    <>
      {menuItems.map((item, index) => (
        <li
          key={index}
          className={`tracking-wider menu-items-animate text-accent mx-auto px-[4vw]`}
        >
          <Link
            to={item.path}
            className={`transition-all ${
              isCurrentPath(item.path)
                ? "translate-x-6"
                : "text-slate-200 opacity-20"
            }`}
          >
            <item.icon fontSize={16} className="mr-3" />
            {item.label}
          </Link>
        </li>
      ))}
    </>
  );
};

export default NavbarMenu;
